import React, { Component } from 'react'
import styles from './InfoButton.module.css'

import FormActions from '../../actions/FormActions'

export default class InfoButton extends Component {
  constructor (props) {
    super(props)
    console.log(styles)
  }

  _onClick () {
    FormActions.setShowInfoMessage(true)
  }

  render () {
    return (
      <div onClick={this._onClick.bind(this)} className={styles.infoButton}>
        <img src={'/static/img/info.png'} className={styles.image} />
        <span className={styles.info}>Viktig information</span>
      </div>
    )
  }
}
